export const ankrTransactionTransformer = (txn) => ({
    blockhash: txn?.blockHash,
    blocktime: txn.blockTime,
    confirmations: txn.confirmations,
    hex: txn.hex,
    locktime: txn?.coinSpecificData?.locktime,
    hash: txn.coinSpecificData?.hash,
    size: txn.size,
    txid: txn.txid,
    version: txn.version,
    vin: txn.vin.map((vin) => ({
        scriptSig: vin.scriptSig,
        sequence: vin.sequence,
        txid: vin.txid,
        vout: vin.vout,
        txinwitness: vin.addresses,
    })),
    vsize: txn.vsize,
    vout: txn.vout.map((vout) => ({
        n: vout.n,
        scriptPubKey: vout.scriptPubKey,
        value: vout.value,
    })),
});
//# sourceMappingURL=utils.js.map